'use client';

import { useIsMobileDevice } from '@hooks/useIsMobileDevice';
import { AppStoreButtons } from '../Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Button } from '../Clickables/Buttons/Button';
import { Heading } from '../Heading/Heading';

interface IProps {
  onCTAClick: () => void;
  sourceId?: string;
  isUA?: boolean;
}

export const TopSpeciesCTA = ({ onCTAClick, sourceId, isUA = false }: IProps) => {
  const isMobileDevice = useIsMobileDevice();
  return (
    <div className="relative flex flex-col">
      <div className="absolute inset-x-0 top-0 flex flex-col">
        <div className="border-b-twilight relative flex w-full items-center gap-4 border-b py-2.5 pr-2 blur-md">
          <div className="relative flex w-full items-center gap-4">
            <div className="bg-twilight h-11 w-28" />
            <div className="flex grow flex-col">
              <div className="bg-twilight h-5 w-1/2" />
            </div>
          </div>
        </div>
        <div className="border-b-twilight relative flex w-full items-center gap-4 border-b py-2.5 pr-2 blur-md">
          <div className="relative flex w-full items-center gap-4">
            <div className="bg-twilight h-11 w-28" />
            <div className="flex grow flex-col">
              <div className="bg-twilight h-5 w-1/2" />
            </div>
          </div>
        </div>
      </div>
      <div className="z-mid mx-auto flex max-w-72 flex-col items-center justify-center gap-4 pt-7 pb-4 text-center">
        <Heading className="mb-0" variant="xs" as="span">
          See all species in the Fishbrain app
        </Heading>
        {isMobileDevice ? (
          <AppStoreButtons
            orientation="vertical"
            source={'TopSpeciesCTA'}
            sourceId={sourceId}
            isUA={isUA}
          />
        ) : (
          <Button
            size="sm"
            className="hidden p-3 sm:flex"
            variant="buttonPrimary"
            onClick={onCTAClick}
          >
            Download Fishbrain
          </Button>
        )}
      </div>
    </div>
  );
};
